import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '../store'

interface DocumentFilterState {
  contactId: string | null
  documentTypeId: string | null
  createdByUserIds: string[] | null
  startDate: Date | null
  endDate: Date | null
}

const initialState: DocumentFilterState = {
  contactId: null,
  documentTypeId: null,
  createdByUserIds: null,
  startDate: null,
  endDate: null,
}

export const documentFilterSlice = createSlice({
  name: 'documentFilter',
  initialState,
  reducers: {
    setDocumentContactFilter: (state, action: PayloadAction<string | null>) => {
      state.contactId = action.payload
    },
    setDocumentTypeFilter: (state, action: PayloadAction<string | null>) => {
      state.documentTypeId = action.payload
    },
    setDocumentCreatedByFilter: (state, action: PayloadAction<string[]>) => {
      state.createdByUserIds = action.payload
    },
    setDocumentStartDateFilter: (state, action: PayloadAction<Date | null>) => {
      state.startDate = action.payload
    },
    setDocumentEndDateFilter: (state, action: PayloadAction<Date | null>) => {
      state.endDate = action.payload
    },
    resetDocumentFilters: () => initialState,
  },
})

export const {
  setDocumentContactFilter,
  setDocumentTypeFilter,
  setDocumentCreatedByFilter,
  setDocumentStartDateFilter,
  setDocumentEndDateFilter,
  resetDocumentFilters,
} = documentFilterSlice.actions

export const selectDocumentContactFilter = (state: RootState) => state.processDocument.documentFilter.contactId

export const selectDocumentTypeFilter = (state: RootState) => state.processDocument.documentFilter.documentTypeId

export const selectDocumentCreatedByFilter = (state: RootState) => state.processDocument.documentFilter.createdByUserIds

export const selectDocumentStartDateFilter = (state: RootState) => state.processDocument.documentFilter.startDate

export const selectDocumentEndDateFilter = (state: RootState) => state.processDocument.documentFilter.endDate
